import PropTypes from 'prop-types';

export const premiumPerksPropType = PropTypes.shape({});

export default PropTypes.shape({});
